import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import { states, cities } from './Doctorstatecity';
import { doctorSpecializations } from './doctorSpecializations'; // Import the specialization list
import './DoctorRegister.css';

const DoctorRegister = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    specialization: '',
    state: '',
    city: '',
    experience: '',
    address: '',
    password: '',
    medicalLicense: null,
    degreeCertificate: null,
    idProof: null,
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const filteredCities = formData.state ? cities[formData.state] : [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    console.log(`File selected for ${name}:`, files[0]?.name);
    setFormData({ ...formData, [name]: files[0] });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const requiredFields = ['name', 'email', 'phone', 'specialization', 'state', 'city', 'experience', 'address', 'password', 'medicalLicense', 'degreeCertificate', 'idProof'];
    if (requiredFields.some(field => !formData[field])) {
      setError('All fields, including document uploads, are required.');
      setIsLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address.');
      setIsLoading(false);
      return;
    }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      setError('Please enter a valid 10-digit phone number.');
      setIsLoading(false);
      return;
    }

    if (formData.experience < 0) {
      setError('Experience cannot be negative.');
      setIsLoading(false);
      return;
    }

    const data = new FormData();
    Object.keys(formData).forEach(key => {
      console.log(`Appending ${key}:`, formData[key]);
      data.append(key, formData[key]);
    });

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://turemedicine-backend-1.onrender.com';
      const response = await axios.post(`${apiUrl}/auth/doctor/register`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('Registration response:', response.data);
      const { accessToken, refreshToken, doctorId } = response.data;
      login({ id: doctorId, role: 'doctor', accessToken, refreshToken });
      navigate(`/doctor-dashboard/${doctorId}`);
    } catch (error) {
      setError(error.response?.data?.error || error.response?.data?.message || `Registration failed: ${error.message}`);
      console.error('Registration failed:', error.response?.data || error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-page">
      <div className="auth-container">
        <h2>Doctor Registration</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleRegister}>
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleInputChange} required />
          <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleInputChange} required />
          <select name="specialization" value={formData.specialization} onChange={handleInputChange} required>
            <option value="">Select Specialization</option>
            {doctorSpecializations.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
          <select name="state" value={formData.state} onChange={handleInputChange} required>
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
          <select name="city" value={formData.city} onChange={handleInputChange} required disabled={!formData.state}>
            <option value="">Select City</option>
            {filteredCities.map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
          <input type="number" name="experience" placeholder="Experience (in years)" value={formData.experience} onChange={handleInputChange} required />
          <input type="text" name="address" placeholder="Clinic Address" value={formData.address} onChange={handleInputChange} required />
          <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleInputChange} required />
          <label>Medical License</label>
          <input type="file" name="medicalLicense" onChange={handleFileChange} accept=".pdf,.jpg,.jpeg,.png" required />
          <label>Degree Certificate</label>
          <input type="file" name="degreeCertificate" onChange={handleFileChange} accept=".pdf,.jpg,.jpeg,.png" required />
          <label>ID Proof</label>
          <input type="file" name="idProof" onChange={handleFileChange} accept=".pdf,.jpg,.jpeg,.png" required />
          <button type="submit" disabled={isLoading}>
            {isLoading ? (
              <span className="spinner"></span>
            ) : (
              'Register'
            )}
          </button>
        </form>
        <p>
          Already have an account?{' '}
          <button onClick={() => navigate('/doctor-login')} className="link-button">Login here</button>
        </p>
      </div>
    </div>
  );
};

export default DoctorRegister;